export default "__VITE_ASSET__fltX7uex__"